import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface GeoLearnMoreModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function GeoLearnMoreModal({ open, onOpenChange }: GeoLearnMoreModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">What is GEO?</DialogTitle>
        </DialogHeader>
        
        <DialogDescription asChild>
          <div className="space-y-4 text-sm text-muted-foreground">
            <p>
              <strong className="text-foreground">GEO (Generative Engine Optimization)</strong> helps you find the right prompt faster by organizing them around how you actually work.
            </p>
            
            <p>
              <strong className="text-foreground">Intent</strong> tells you what a prompt does: generate content, analyze data, transform text, have conversations, or write code.
            </p>
            
            <p>
              <strong className="text-foreground">Use-Case</strong> shows where it's useful: marketing, debugging, brainstorming, meeting notes, and 25+ other scenarios.
            </p>
            
            <p>
              <strong className="text-foreground">Trust signals</strong> let the community verify prompts. Look for 'Author Tested' badges and 'verified' counts to find prompts that actually work.
            </p>
            
            <p>
              No more scrolling through random categories. Find exactly what you need, when you need it.
            </p>
          </div>
        </DialogDescription>
        
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)} className="w-full sm:w-auto">
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
